import React, { useEffect, useState } from "react";
import { STORAGE, makeRequestAuth } from "../../utils/globals";
import {
  Button,
  Icon,
  IconButton,
  Popover as InitialPopover,
  Typography,
} from "@plum-xoxo/admin-dsm";
import theme from "../../theme/theme";
import { useLocation, Link } from "react-router-dom";
import FestiveGifting from "./FestiveGifting";
import posthog from "posthog-js";
import config from "config";
import styled from "styled-components";
import Sidebar from "../Sidebar";
import axios from "axios";
import { app_path } from "config";
import BulkGifting from "./BulkGifting";
import Exclusive from "./Exclusive";
import MFAModal from "../../modules/MFA/MFAModal";
import DiwaliGifting from "./DiwaliGifting";

const CustomPopoverHoverBackground = styled(Typography).attrs()`
 .eui-option-inner{
  padding-top:12px ;
  padding-bottom:12px ;
 }
 .eui-option-inner:hover{
    background-color: ${(props) => props.theme.palette.light.c100};
},`;

const StyledTypography = styled(Typography.H3).attrs()`
  white-space: nowrap;
  color: ${(props) => props.theme.palette.dark.c200};
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  &:hover {
    color: ${(props) => props.theme.palette.dark.c300};
  }
`;

const HeaderAvatar = styled.div`
  background: ${theme.palette.yellow.c200};
  color: ${theme.palette.dark.c300};
  border-radius: 100%;
  height: 32px;
  width: 32px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
`;

const Popover = styled(InitialPopover).attrs()`
  padding: 0;
`;

const StyledWarningBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.yellow.c000};
  height: 40px;
  margin: 0px;
`;

const StyledDangerBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.orange.c000};
  height: 40px;
  margin: 0px;
`;

const StyledInfoBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.light.c100};
  height: 40px;
  margin: 0px;
`;

const StyledPrimaryBanckGrounddDiv = styled.div`
  background-color: ${(props) => props.theme.palette.primary.c05};
  height: 40px;
  margin: 0px;
`;

const StyledSuccessDiv = styled.div`
  background-color: ${(props) => props.theme.palette.green.c000};
  height: 40px;
  margin: 0px;
`;

const KybMessage = (props) => {
  const { kybStatus, setDismissKyb } = props;
  const mfaData = props.accountReducer?.mfaData;

  const handleDismiss = () => {
    sessionStorage.setItem("dismissKyb", true);
    setDismissKyb(true);
  };
  const addAuthentication = () => {
    props.updateMFAData({ ...mfaData, showMFAModal: true });
  };

  return (
    <>
      {mfaData?.showMFAModal ? (
        <MFAModal
          updateMFAData={props.updateMFAData}
          mfaData={mfaData}
          showMFAModal={mfaData?.showMFAModal}
          accountReducer={props.accountReducer}
        />
      ) : null}
      {kybStatus === 2 && props.showMFABanner ? (
        <>
          <StyledDangerBackgroundDiv className="fixed-top d-flex justify-content-center align-items-center">
            <Typography.BodySmall component="div" color="dark" shade="c200">
              Add two-step authentication to enhance your account security.{" "}
              <Button
                variant="plain"
                onClick={addAuthentication}
                className="cursor-pointer p-0"
              >
                Add Authentication
              </Button>
            </Typography.BodySmall>
          </StyledDangerBackgroundDiv>
        </>
      ) : kybStatus === 2 ? (
        <>
          <StyledSuccessDiv className="fixed-top d-flex justify-content-center align-items-center">
            <Typography.BodySmall component="div" color="dark" shade="c200">
              Your business is verified. You can now send rewards and add funds
              to your wallet.{" "}
              <Button
                variant="plain"
                onClick={handleDismiss}
                className="cursor-pointer p-0"
              >
                Dismiss
              </Button>
            </Typography.BodySmall>
          </StyledSuccessDiv>
        </>
      ) : kybStatus === 0 ? (
        <StyledPrimaryBanckGrounddDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            <Link to={`/${app_path}/accounts/platform-preferences#submit-kyb`}>
              <Typography.BodySmall
                component="span"
                color="primary"
                shade="c02"
                className="cursor-pointer"
              >
                {" "}
                Verify your business{" "}
              </Typography.BodySmall>{" "}
            </Link>
            to get full access to Xoxoday platform.
          </Typography.BodySmall>
        </StyledPrimaryBanckGrounddDiv>
      ) : kybStatus === 1 ? (
        <StyledInfoBackgroundDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            Business verification is in process.You will get full access to
            Xoxoday platform after verification.
          </Typography.BodySmall>
        </StyledInfoBackgroundDiv>
      ) : kybStatus === 3 || kybStatus === 5 ? (
        <StyledWarningBackgroundDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            Unable to verify your business details.{" "}
            <Link to={`/${app_path}/accounts/platform-preferences#submit-kyb`}>
              <Typography.BodySmall
                component="span"
                color="blue"
                shade="c200"
                className="cursor-pointer"
              >
                {" "}
                Resubmit for verification{" "}
              </Typography.BodySmall>{" "}
            </Link>
            to get full access to Plum platform.{" "}
          </Typography.BodySmall>
        </StyledWarningBackgroundDiv>
      ) : null}
    </>
  );
};

const Header = (props) => {
  const {
    companyDetails: { company_primary_logo } = {},
    employeeDetails: {
      domain = "marketplace",
      employee_first_name = "",
      employee_full_name = "",
      employee_email = ""
    } = {},
    employeeDetails = {},
    showNotificationBar,
    accountReducer: {
      typeData: { role = 1 } = {},
      moduleAcl = [],
      kybStatus = {},
    },
    privateRoutes,
    history,
    isFirstRewardSent = true,
    mfaData,
  } = props;
  const currency = props.accountReducer?.userBalance?.currencyCode || "INR";

  const [accounts, setAccounts] = useState([]);
  const [dismissKyb, setDismissKyb] = useState(false);
  let url = config.storeFrontURL.replace(/\/$/g, "");
  const showMFABanner =
    mfaData?.res?.length && mfaData?.res?.[0]?.skip_mfa == 1;
  const typeformParams = `#name=${employee_full_name}&email=${employee_email}`

  const fetchAccounts = async () => {
    const url = `${config.auth_url}/switchapi/fetch_accounts`;
    const payload = {};
    const headers = {
      "Content-Type": "application/json",
      pltfm: 4,
      lng: "en",
    };
    try {
      const { data } = await axios(url, {
        method: "post",
        data: payload,
        withCredentials: true,
        headers: headers,
      });
      setAccounts(data.linkedAccounts);
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const accountLogout = () => {
    makeRequestAuth(
      {},
      function () {
        STORAGE("jose", "", 1);
        STORAGE("login_email", "", 1);
        STORAGE("e_login", "", 1);
        STORAGE("e_points", "", 1);
        STORAGE("member_id", "", 1);
        STORAGE("logo_url", "", true);

        let delete_params = STORAGE("delete_params")
          ? STORAGE("delete_params").split(",")
          : [];
        for (var i = 0; i < delete_params.length; i++) {
          STORAGE(delete_params[i], "", 1);
        }
        STORAGE("delete_params", "", 1);
        sessionStorage.removeItem("xoxoPointsState");
        sessionStorage.removeItem("xoxoCodeState");
        sessionStorage.removeItem("xoxoLinkState");
        sessionStorage.removeItem("AutomationCreationData");
        sessionStorage.removeItem("dismissKyb");
        posthog.reset();
        window.location.href = config.storeFrontURL;
      }.bind(this),
      {},
      "/logout"
    );
  };

  useEffect(() => {
    fetchAccounts();
    const dismissKybSess =
      JSON.parse(sessionStorage.getItem("dismissKyb")) || false;
    setDismissKyb(dismissKybSess);
    !(mfaData?.res?.length && mfaData?.res?.[0]?.skip_mfa) &&
      kybStatus?.kyb_status === 2 &&
      props.updateMFAData({ ...mfaData, showMFAModal: true });
  }, []);
  return (
    <>
      <KybMessage
        kybStatus={kybStatus?.kyb_status}
        history={history}
        setDismissKyb={setDismissKyb}
        showMFABanner={showMFABanner}
        {...props}
      />
      <div
        style={{
          marginTop:
            (!dismissKyb && !isFirstRewardSent) || showMFABanner ? "40px" : 0,
          height: "52px",
          backgroundColor: theme.palette.common.white,
          borderBottom: `1px solid ${theme.palette.light.c300}`,
        }}
        className="d-flex align-items-center p-6 fixed-top"
      >
        <Popover
          content={
            <div className="p-24">
              <Typography.ButtonText
                color="dark"
                shade="c200"
                className="mb-12"
              >
                Other apps by Giift
              </Typography.ButtonText>
              <Popover.Options
                onClick={() => {
                  window.open(
                    "https://www.empuls.io/get-in-touch-with-the-culture-experts/plum",
                    "_blank"
                  );
                }}
              >
                <img
                  src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1704689821/store/Logo/empuls-logo.png"
                  alt=""
                  width={105}
                />
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  component="div"
                  className="mt-12"
                >
                  Our all-in-one employee engagement <br /> platform to connect,
                  listen, appreciate, <br /> reward and celebrate your people.
                </Typography.BodySmall>
              </Popover.Options>
              <Popover.Options
                onClick={() => {
                  window.open(
                    "https://www.getcompass.ai/book-a-demo/plum",
                    "_blank"
                  );
                }}
                className="mt-12"
              >
                <img
                  src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1704689821/store/Logo/compass-logo.png"
                  alt=""
                  width={130}
                />
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  component="div"
                  className="mt-12"
                >
                  Our commission automation platform that <br /> lets sales
                  teams focus on driving revenue.
                </Typography.BodySmall>
              </Popover.Options>
            </div>
          }
          offset={[0, 15]}
          onOverlayClick={() => {}}
          onVisibilityChange={function noRefCheck() {}}
          placement="bottom-start"
          width={367}
        >
          <IconButton variant="plain">
            <Icon
              iconName="PlumGrid"
              onClick={() => {}}
              color="dark"
              shade="c200"
              size="m"
              className="p-10"
            />
          </IconButton>
        </Popover>

        <Link to={`/${app_path}/dashboard`}>
          <img
            alt="xoxoday"
            className="ml-20"
            style={{ height: "24px" }}
            src={
              company_primary_logo ||
              "https://res.cloudinary.com/dyyjph6kx/image/upload/v1702459096/store/Logo/xoxoday_by_giifts.svg"
            }
          />
        </Link>
        <div className="ml-auto d-flex flex-row align-items-center">
          {config.diwaliGifting && currency === "INR" ? <DiwaliGifting typeformParams={typeformParams}  currency={currency}/> : null}
          {config.festiveGifting ? <FestiveGifting typeformParams={typeformParams} currency={currency} /> : null}
          {config.exclusive ? <Exclusive typeformParams={typeformParams} currency={currency} /> : null}
          {config.bulkGifting ? <BulkGifting typeformParams={typeformParams} currency={currency} /> : null}
          <a
            href="https://helpcenter.xoxoday.com/docs/getting-started"
            target="_blank"
            rel="noreferrer"
            className="mr-28"
          >
            <Icon
              color="dark"
              shade="c200"
              iconName="Help"
              size="s"
              className="d-inline-block mr-8"
            />
            <Typography.LabelText component="span" color="dark" shade="c200">
              Support
            </Typography.LabelText>
          </a>

          <Popover
            content={
              <>
                <Popover.Options className="mx-4 my-8">
                  <Link
                    to={`/${app_path}/accounts/profile`}
                    className="d-flex align-items-center"
                  >
                    <div>
                      <HeaderAvatar className="d-flex align-items-center justify-content-center">
                        <Typography component="span">
                          {employee_first_name?.charAt(0) || ""}
                        </Typography>
                      </HeaderAvatar>
                    </div>
                    <div className="ml-8">
                      <Typography component="div">
                        {employee_first_name
                          ? employee_full_name.charAt(0).toUpperCase() +
                            employee_full_name.substring(1, 12)
                          : ""}
                        {employee_full_name?.length > 12 ? "..." : ""}
                      </Typography>
                      <Typography.BodySmall
                        component="div"
                        color="dark"
                        shade="c200"
                      >
                        {role === 1 ? "Super Admin" : "Admin"}
                      </Typography.BodySmall>
                    </div>
                    <div className="ml-auto">
                      <Icon iconName="RightArrow" color="dark" shade="c200" />
                    </div>
                  </Link>
                </Popover.Options>
                <hr className="m-0" />
                <Popover.Options className="mx-4 mt-8" width={240}>
                  <a href={`${url}/${domain}`} target="_blank">
                    <Typography component="div" color="dark" shade="c300">
                      Visit Storefront
                    </Typography>
                    <Typography.BodySmall
                      component="div"
                      color="dark"
                      shade="c100"
                    >
                      /{domain}
                    </Typography.BodySmall>
                  </a>
                </Popover.Options>
                {accounts.length > 1 ? (
                  <Popover.Options className="mx-4">
                    <a href={`${url}/${domain}/switch-account`}>
                      <Typography component="div" color="dark" shade="c300">
                        Switch Account
                      </Typography>
                      <Typography.BodySmall
                        component="div"
                        color="dark"
                        shade="c100"
                      >
                        {employee_full_name}
                      </Typography.BodySmall>
                    </a>
                  </Popover.Options>
                ) : (
                  ""
                )}

                <Popover.Options
                  className=" mx-4 mb-16"
                  onClick={accountLogout}
                >
                  <Typography component="div" color="red" shade="c200">
                    Logout
                  </Typography>
                </Popover.Options>
              </>
            }
            offset={[0, 0]}
            onOverlayClick={() => {}}
            onVisibilityChange={function noRefCheck() {}}
            placement="bottom-end"
            trigger="hover"
          >
            <IconButton variant="plain" className="mr-36">
              <HeaderAvatar className="d-flex align-items-center justify-content-center">
                <Typography component="span">
                  {employee_first_name?.charAt(0) || ""}
                </Typography>
              </HeaderAvatar>
            </IconButton>
          </Popover>
        </div>
      </div>

      <div className="d-flex mt-52">
        <Sidebar
          history={history}
          moduleAcl={moduleAcl}
          kyb_status={kybStatus?.kyb_status}
          isFirstRewardSent={isFirstRewardSent}
        />
        {privateRoutes()}
      </div>
    </>
  );
};

export default Header;